import { ProfMaterials, Cards } from '../types';

const parseMaterials = (data: ProfMaterials | undefined): Cards => {
  if (!data || !data.length) return [];
  return data.map((item: any) => ({
    id: String(item.id),
    title: item.name,
    code: '',
    img: {
      large: item.image,
      small: item.image,
    },
    to: item.url,
  }));
};

export default parseMaterials;



// WEBPACK FOOTER //
// ./src/services/smart/utils/parseMaterials.ts